import { withProtocol } from "ufo";

export const cloudApiUrl = import.meta.env.VITE_CLOUD_API_URL || window.location.origin;
export const serverApiUrl = import.meta.env.DEV ? import.meta.env.VITE_DISKO_SERVER_URL : new URL("api/disko/", window.location.origin).toString();
export const cloudClientUrl = import.meta.env.VITE_CLOUD_CLIENT_URL || window.location.origin;
export const textServiceUrl = import.meta.env.DEV ? import.meta.env.VITE_DISKO_TEXT_SERVICE_URL : new URL("api/disko/text-service/", window.location.origin).toString();

export const textServiceWSUrl = withProtocol(textServiceUrl, import.meta.env.PROD ? "wss://" : "ws://");
